import React from "react";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

import "../assets/scss/index.scss";

// ** Declare Theme Provider
const MaterialThemeProvider = ({ children }) => {
    const themeConfig = {
        palette: {
            mode: "dark",
            primary: {
                main: "#2dbad9",
            },
            secondary: {
                main: "#68d9b4",
            },
            background: {
                default: "#121227",
                paper: "#181837",
            },
            common: {
                black: "#121227",
                white: "#fff",
                lightBlue: "#c1d9ea",
                darkBlue: "#31536f",
            },
            white: {
                main: "#fff",
            },
            gray: {
                main: "#4f4f4f",
            },
        },
        shape: {
            borderRadius: 12,
        },
        typography: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 14,
        },
        components: {
            MuiTooltip: {
                styleOverrides: {
                    arrow: {
                        color: "#492b66",
                    },
                    tooltip: {
                        background: "#492b66 !important",
                        fontSize: 14,
                        color: "rgb(191, 191, 191)",
                        fontWeight: "100",
                    },
                },
            },
        },
    };

    const theme = createTheme(themeConfig);
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};
export default MaterialThemeProvider;
